




































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';

import moment from 'moment';
import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';

import ErrorAlert from '../common/ErrorAlert.vue';
import RequestStatusDisplay from '../request-common/RequestStatusDisplay.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';

import {
  IVacationCarryOverRequest,
  IVacationCarryOverRequestData,
  VacationCarryOverRequest
} from '@/models';

export default Vue.extend({
  name: 'VacationCarryOverRequestActivityDialog',

  components: { ErrorAlert, RequestStatusDisplay, ALDialog },
  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    request: {} as IVacationCarryOverRequestData,

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Changed By',
        align: 'start',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Previous State',
        align: 'center',
        sortable: false,
        value: 'source_state'
      },
      {
        text: 'Current State',
        align: 'center',
        sortable: false,
        value: 'state'
      }
    ]
  }),

  computed: {
    vacationCarryOverRequestActivities: get<Transition[]>(
      'vacationCarryOverRequest/getVacationCarryOverRequestActivities'
    ),

    VacationCarryOverRequest: () => VacationCarryOverRequest
  },

  methods: {
    moment,

    ...mapActions({
      fetchVacationCarryOverRequestActivities:
        'vacationCarryOverRequest/fetchVacationCarryOverRequestActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(vacationCarryOverRequest: IVacationCarryOverRequest) {
      this.clearAllErrors();

      this.request = vacationCarryOverRequest;

      this.dialog = true;
      this.loading = true;

      this.fetchVacationCarryOverRequestActivities(vacationCarryOverRequest.id)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    }
  }
});
